import { createSelector } from 'reselect';
import { RootState } from 'Store/Reducers/RootReducer';

const getTaskStore = (state: RootState) => state.taskStore;
const getTasksByLesson = createSelector(getTaskStore, (state) => state.tasksByLesson);
const getSaveTasks = createSelector(getTaskStore, (state) => state.saveTasks);
const getSingleSaveTask = createSelector(getTaskStore, (state) => state.singleSaveTask);

export {  getTasksByLesson, getSaveTasks, getSingleSaveTask };
